var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_300_3028",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_300_3028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0.328125 0.902344L0 1.8457V2.78906L1.3125 5.00391L0 7.21875V8.53125L1.3125 10.5L0 12.4688V13.7812L1.3125 15.9961L0 18.2109V21L0.902344 20.6719L1.8457 21H2.78906L5.00391 19.6875L7.21875 21H8.53125L10.5 19.6875L12.4688 21H13.7812L15.9961 19.6875L18.2109 21H21L20.6719 20.0977L21 19.1543V18.2109L19.6875 15.9961L21 13.7812V12.4688L19.6875 10.5L21 8.53125V7.21875L19.6875 5.00391L21 2.78906V0L20.0977 0.328125L19.1543 0H18.2109L15.9961 1.3125L13.7812 0H12.4688L10.5 1.3125L8.53125 0H7.21875L5.00391 1.3125L2.78906 0H0Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 0V4.42969L18.2109 0H13.7812ZM21 2.78906L16.5703 7.21875H21V2.78906ZM0 7.21875H4.42969L0 2.78906V7.21875ZM2.78906 0L7.21875 4.42969V0H2.78906ZM7.21875 21V16.5703L2.78906 21H7.21875ZM0 18.2109L4.42969 13.7812H0V18.2109ZM21 13.7812H16.5703L21 18.2109V13.7812ZM18.2109 21L13.7812 16.5703V21H18.2109Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V1.8457L5.37305 7.21875H7.21875L0 0ZM8.53125 0V8.53125H0V12.4688H8.53125V21H12.4688V12.4688H21V8.53125H12.4688V0H8.53125ZM19.1543 0L13.7812 5.37305V7.21875L21 0H19.1543ZM7.21875 13.7812L0 21H1.8457L7.21875 15.627V13.7812ZM13.7812 13.7812L21 21V19.1543L15.627 13.7812H13.7812Z",
    fill: "#D80027"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnEn);
export default __webpack_public_path__ + "static/media/en-En.297d3ecdaf7467848922f11b9e27f219.svg";
export { ForwardRef as ReactComponent };